var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadItemsCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66666 0.666626H1.99999C1.08333 0.666626 0.341662 1.41663 0.341662 2.33329L0.333328 15.6666C0.333328 16.5833 1.07499 17.3333 1.99166 17.3333H12C12.9167 17.3333 13.6667 16.5833 13.6667 15.6666V5.66663L8.66666 0.666626ZM12 15.6666H1.99999V2.33329H7.83333V6.49996H12V15.6666ZM3.66666 11.5083L4.84166 12.6833L6.16666 11.3666V14.8333H7.83333V11.3666L9.15833 12.6916L10.3333 11.5083L7.00833 8.16663L3.66666 11.5083Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadItemsCsv);
export default __webpack_public_path__ + "static/media/icon-upload-items-csv.903d84d05168a5eb51030656c63ff6cd.svg";
export { ForwardRef as ReactComponent };